import ImageRounded from './ImageRounded'

export default ImageRounded